export const paymentTypes = (state = {}, action) => {
  switch (action.type) {
    case 'SAVE_PAYMENT_TYPES':
      return action.data;
    default:
      return state;
  }
};

export const currentPaymentType = (state = null, action) => {
  switch (action.type) {
    case 'SET_PAYMENT_TYPE':
      return action.data;
    default:
      return state;
  }
};
